/*
 Suggestions widget
 -------------
 */

define(function(require) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var tmpl = require('tmpl');
    var Swipe = require('class/swipe.class');
    var mathAlgorithms = require('util/math.util').algorithms;

    require('common/jbone.widget');

    return $.widget('suggestions', {

        /**
         * Options by default
         * @type {Object}
         */
        options: {
            /**
             * Suggested amount value by default,
             * it will be added like amount field value
             * @type: {String}
             */
            defaultValue: '',

            /**
             * Amount field
             * @type: {HTMLElement}
             */
            amountField: null,

            /**
             * Container relative to which
             * happen calculation offset of suggestions list
             * @type: {HTMLElement}
             */
            viewport: document.body,

            /**
             * List of suggestions
             * @type {Array}
             */
            suggestions: null,

            /**
             * Type of payment method, supported values: `deposit`
             * @type: {String}
             */
            paymentType: '',

            /**
             * Enable/disable swipe logic
             * @type {Boolean}
             */
            enableSwipeLogic: true
        },

        init: function(options) {
            this.eventsNamespace = '.suggestions_wgt_' + _.uniqueId();
            this.options = _.defaults(options, this.options);
            if (this._isSuggestionsEnabled()) {
                this.render().subscribe();
            }
            if (this.options.enableSwipeLogic) {
                this.attachSwipe();
            }
        },

        render: function() {
            this.$el.append($(tmpl['suggestions.widget'](this.options)));
            $(this.options.amountField).val(this.options.defaultValue).trigger('blur');
            return this;
        },

        subscribe: function() {
            this.on(this.$el, {
                'tap .fn-one-suggestion': this.handleSuggestionTap.bind(this),
                'tapHover .fn-one-suggestion': this.manageHoverClass.bind(this, 'add'),
                'tapRemoveHover .fn-one-suggestion': this.manageHoverClass.bind(this, 'remove')
            });
            if (this.options.enableSwipeLogic) {
                $(window).on('resize' + this.eventsNamespace, _.debounce(this.alignSuggestions.bind(this), 200));
            }
        },

        destroy: function() {
            $.Widget.prototype.destroy.call(this);
            $(window).off(this.eventsNamespace);
        },

        manageHoverClass: function(action, e) {
            e.currentTarget.classList[action]('hover');
        },

        handleSuggestionTap: function(e) {
            var amount = $(e.currentTarget).find('.fn-suggestion-amount');
            var value = amount.length ? amount[0].dataset.amount.trim() : '';
            $(this.options.amountField).val(value).trigger('blur');
        },

        attachSwipe: function() {
            if (this._isSuggestionsEnabled() && !this.suggestionsSwipe) {

                this.suggestionsSwipe = new Swipe(this.$('.fn-suggestions'), {
                    detectingStrategy: function(swipe, touch) {
                        var isDetecting = Swipe.detectingStrategies.x.call(swipe, swipe, touch);
                        var isSwipe = this._checkSwipe();
                        return isDetecting && isSwipe;
                    }.bind(this)
                });

                this.suggestionsSwipe.on({
                    move: this._handleTouchMove,
                    end: this._handleTouchEnd.bind(this)
                });

                this.alignSuggestions({
                    preventAnimation: true,
                    callback: function() {
                        this.$('.fn-suggestions-wrapper').removeClass('invisible');
                    }.bind(this)
                });
            }
        },

        isSwipeAttached: function(callback) {
            callback(Boolean(this.suggestionsSwipe));
        },

        _isSuggestionsEnabled: function() {
            return this.options.amountField &&
                this.options.suggestions &&
                this.options.paymentType === 'deposit';
        },

        _checkSwipe: function() {
            var viewport = this.options.viewport;
            var list = this.$('.fn-suggestions')[0];
            return viewport.clientWidth - list.clientWidth <= 0;
        },

        alignSuggestions: function(options) {
            options = options || {};

            var container = this.$el[0];
            var viewport = this.options.viewport;
            var list = this.$('.fn-suggestions')[0];

            if (this.suggestionsSwipe && list.clientWidth) {
                var diff = viewport.clientWidth - list.clientWidth;
                var shift = diff > 0 ? container.clientWidth - list.clientWidth : 0;

                if (options.preventAnimation) {
                    this.suggestionsSwipe.translate(shift / 2, 0, 0);
                    if (options.callback) {
                        _.defer(options.callback);
                    }
                    return;
                }

                this.suggestionsSwipe.animateTo(shift / 2, 0, 300, mathAlgorithms.easeInQuad, options.callback);
            }
        },

        _handleTouchMove: function(item) {
            item.translate(item.start.x - item.delta.x, 0);
        },

        _handleTouchEnd: function(item) {
            var expected = item.position.x;
            var container = this.$el[0];
            var isStart = item.position.x > 0;
            var isEnd = Math.abs(item.position.x) >= Math.abs(container.clientWidth - item.el.clientWidth);

            if (isStart) {
                expected = 0;
            } else if (isEnd) {
                expected = container.clientWidth - item.el.clientWidth;
            }

            item.animateTo(expected, 0, 300, mathAlgorithms.easeInQuad);
        }

    });
});
